import React from 'react';
type ArtifactViewMainContentSignaturesComponentVersionPackageManagerSBTProps = {
  component: object;
  version: object;
};
const ArtifactViewMainContentSignaturesComponentVersionPackageManagerSBT: React.SFC<
  ArtifactViewMainContentSignaturesComponentVersionPackageManagerSBTProps
> = props => {
  let component = props.component,
    version = props.version;
  return (
    <div className="grid">
      <div className="grid__item col-1-1 pt-- pl0">
        <div className="font-family--code bg-color--black-dark p- color--white phone--font--h7 phone--no-overflow">
          libraryDependencies += "{component.coordinate1}" % "{component.coordinate2}" % "
          {version.version}"
        </div>
      </div>
    </div>
  );
};
export default ArtifactViewMainContentSignaturesComponentVersionPackageManagerSBT;
